/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TesterNavigationMobileMenuService {
  private readonly openSubject = new BehaviorSubject<boolean>(false);
  readonly isOpen$ = this.openSubject.asObservable().pipe(distinctUntilChanged());

  toggle(): void {
    this.openSubject.next(!this.openSubject.value);
  }

  close(): void {
    this.openSubject.next(false);
  }
}
